import { useComputedColorScheme, useMantineColorScheme } from '@mantine/core';

export function useTheme() {
  const {colorScheme, setColorScheme, toggleColorScheme} = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light');

  const isDark = computedColorScheme === 'dark';

  const toggleTheme = () => {
    setColorScheme(computedColorScheme === 'dark' ? 'light' : 'dark');
  };

  return {
    colorScheme,
    computedColorScheme,
    isDark,
    setColorScheme,
    toggleTheme,
    toggleColorScheme,
  };
}
